import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Services from './components/Services';
import Rheuma from './components/Rheuma';
import About from './components/About';
import Team from './components/Team';
import Contact from './components/Contact';
import './App.css';
import Datenschutz from './components/pages/Datenschutz';
import Impressum from './components/pages/Impressum';
import Gallery from './components/pages/Gallery';

export default function App() {
  return (
    <Router>
      <Navigation />

      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <Services />
            <Rheuma />
            <Team />
            <About />
            <Contact />
          </>
        } />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
      <Footer />
    </Router>
  );
}
